import { storeOrUpdateAtpFeed } from '@/api/title'
import { getCorporations } from '@/api/open'


export default {
    components: {},
    props: {
        titleForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ describe: '' })
        }
    },
    created(){
        if(this.model.titles){
            this.titles = this.model.titles.join('\n')
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            show: false,
            titles: '',
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        },
        rules() {
            if (this.model.id) {
                return {
                    title_group_name: [{ required: true, message: '请填写标题组名称', trigger: 'change' }],
                    name: [{ required: true, message: '请填写标题', trigger: 'change' }],
                };
            } else {
                return {
                    title_group_name: [{ required: true, message: '请填写标题组名称', trigger: 'change' }],
                    // titles: [{ required: true, message: '请填写标题', trigger: 'change' }],
                };
            }
        }
    },
    mounted() {
        getCorporations().then(res => { this.corporations = res.data.list || [] })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            if (!this.model.id) {
                let titles = this.titles.split('\n')
                titles = titles.filter(Boolean)
                if (titles.length < 1) {
                    return this.$message.error('请填写标题')
                }
                this.model.titles = titles
                this.model.name = this.model.title_group_name
            }

            const data = Object.assign({}, this.model)

            this.loading = true
            storeOrUpdateAtpFeed(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:titleForm', false)
        },
    }
}
